import CheckedIcon from '@mui/icons-material/Check';
import { Box, ToggleButton, Typography } from '@mui/material';
import {
  CommType,
  DeliveryType,
  ICommsFilter,
  commTypes,
  deliveryTypes
} from '../../../../hooks/use-communications/use-communications-filter';
import { FilterToggleButtonGroup } from '../../../shared/filter/filter.styles';
import { FilterContainer } from '../filter-widget/styles/inbox-filter-styles';
import { InboxSectionSeparator, OverlineText } from '../inbox-widget/styles/inbox-styles';

interface CommsFilteringPanelProps {
  filterPre: ICommsFilter;
  onFilterPreselected: (filterPre: Partial<ICommsFilter>) => void;
}

export default function CommsFilteringPanel({ filterPre, onFilterPreselected }: CommsFilteringPanelProps) {
  const onCommTypeChange = (_event: React.MouseEvent<HTMLElement>, newCommType: CommType) => {
    onFilterPreselected({ commType: newCommType });
  };

  const onDeliveryTypeChange = (_event: React.MouseEvent<HTMLElement>, newDeliveryType: DeliveryType) => {
    onFilterPreselected({ deliveryType: newDeliveryType });
  };

  return (
    <FilterContainer>
      <InboxSectionSeparator>
        <OverlineText variant="overline">Channel</OverlineText>
      </InboxSectionSeparator>
      <Box>
        <FilterToggleButtonGroup
          value={filterPre.commType}
          exclusive
          onChange={onCommTypeChange}
          aria-label="communication type"
        >
          {commTypes.map((commType, index) => (
            <ToggleButton key={index} value={commType}>
              {filterPre.commType === commType && <CheckedIcon sx={{ fontSize: 'small', mr: 1 }} />}
              <Typography variant="body2" textTransform="none" color="#0259AB">
                {commType}
              </Typography>
            </ToggleButton>
          ))}
        </FilterToggleButtonGroup>
      </Box>
      <InboxSectionSeparator>
        <OverlineText variant="overline">Type</OverlineText>
      </InboxSectionSeparator>
      <Box>
        <FilterToggleButtonGroup
          value={filterPre.deliveryType}
          exclusive
          onChange={onDeliveryTypeChange}
          aria-label="communication delivery type"
        >
          {deliveryTypes.map((deliveryType, index) => (
            <ToggleButton key={index} value={deliveryType}>
              {filterPre.deliveryType === deliveryType && <CheckedIcon sx={{ fontSize: 'small', mr: 1 }} />}
              <Typography variant="body2" textTransform="none" color="#0259AB">
                {deliveryType}
              </Typography>
            </ToggleButton>
          ))}
        </FilterToggleButtonGroup>
      </Box>
    </FilterContainer>
  );
}
